<template>
  <customer-profile />
</template>

<script>
import CustomerProfile from "@/components/3pl/CRM/CustomerProfile/CustomerProfile";
export default {
  components: {
    CustomerProfile,
  },
};
</script>

<style></style>
